export default {
  methods: {
    resetForm() {
      this.$validator.pause();
      this.$nextTick(() => {
        this.$validator.errors.clear();
        this.$validator.fields.items.forEach(field => field.reset());
        this.$validator.fields.items.forEach(field => this.veeErrors.remove(field));
        this.$validator.resume();
      });
    },
  },
};
